import { render } from "./choiceQuarter.vue?vue&type=template&id=e818c47a&scoped=true"
import script from "./choiceQuarter.vue?vue&type=script&lang=js"
export * from "./choiceQuarter.vue?vue&type=script&lang=js"

import "./choiceQuarter.vue?vue&type=style&index=0&id=e818c47a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e818c47a"]])

export default __exports__